import * as $ from 'jquery';
import 'bootstrap';
import {Result} from "./Result.js";
import {UserFieldValidator} from "./UserFieldValidator";
import _ from 'lodash';
import {ImageViewer} from "../components/ImageViewer";

export default (function () {
  let changesExist = false;
  let leaveConfirmationPopupIsHidden = false;
  const registerChanges = () => changesExist = true;
  const disableLeaveConfirmationPopup = () => leaveConfirmationPopupIsHidden = true;

  window.onbeforeunload = (e) => {
    if (leaveConfirmationPopupIsHidden) {
      leaveConfirmationPopupIsHidden = false;

      return void(0);
    }

    return changesExist || void(0);
  };

  let $wizardContainer = $('#wizard-container');

  $('.zoom-image').each(async (index, element) => {
    const viewer = new ImageViewer({
      element,
      size: {
        width: 1000,
        height: 700,
      }
    });
    
    await viewer.load();
    
    element.classList.add('zoom-image__loaded');
    
    if (element.dataset.viewStep) {
      const $panelHead = $(`div#${element.dataset.viewStep}View`);
      const $historyView = $('div#historyView');
      
      $panelHead.find('div.waiting-wrapper').addClass('d-none');
      $panelHead.find('a').removeClass('d-none');
      
      if ($('.zoom-image__loaded').length === $('.zoom-image').length) {
        $historyView.find('div.waiting-wrapper').addClass('d-none');
        $historyView.find('a').removeClass('d-none');
      }
    }
  });

  if (0 < $wizardContainer.length || 0 < $('#view-container').length) {
    let resultSteps = ['front', 'face'];

    if ($wizardContainer.find('span[data-step][data-name=backImage]').length > 0) {
      resultSteps.push('back');
    }

    let result = new Result(resultSteps);

    let $wizard = $('#wizard-container');
    let $buttonResult = $('button#result');
    let $okModalButton = $('div#modal-save button.ok-button');
    let $steps = $('span.step');

    const handleVerificationStepResult = (step, stepResult) => {
      result.setStepResult(step, stepResult);

      $wizardContainer.find(`button.result[data-step=${step}]`).each(function () {
        if (stepResult === $(this).data('result')) {
          $(this).addClass('checked')
        } else {
          $(this).removeClass('checked');
        }
      })
      if (result.ready) {
        let final = result.final === Result.Passed ? 'Pass' : 'Fail';

        $('div#modal-save button.ok-button').text(final);
        $('div#modal-save h4').text(`${final} this User?`)

        $buttonResult.removeAttr('disabled');
      } else {
        $buttonResult.attr('disabled');
      }

      $(`button.result[data-step=final][data-result=${Result.Passed}]`).prop('disabled', !result.finalCanBeFull);

      if (!result.finalCanBeFull && result.final === Result.Passed) {
        handleVerificationStepResult('final', Result.Failed);
      }
    };

    if (0 < $wizardContainer.length) {
      let $applicantForm = $('form.applicant_form');
      let _newFieldTpl = _.template($('#newFieldTpl').html());
      let _newFieldViewTpl = _.template($('#newFieldViewTpl').html())
      let $newFieldButtonContainer = $('div#newFieldButton');
      let $selectContainer = $('div#selectFields');
      let $removeFieldButtonContainer = $('div.remove-field')

      $applicantForm.on('change', registerChanges);
      $applicantForm.on('input', registerChanges)

      function pullChanges($elem) {
        let name = $elem.attr('id');
        let value = $elem.val();

        $('span.fillable').each(function () {
          if (name === $(this).data('name')) {
            $(this).text(value);
          }
        })
      }

      $newFieldButtonContainer.children('button').on('click', function () {
        $removeFieldButtonContainer.children('button').removeClass('d-none');
        $selectContainer.children('select').removeClass('d-none');
        $(this).addClass('d-none');
      });

      $removeFieldButtonContainer.children().on('click', function () {
        if($(this).data('field-name')) {
          $selectContainer.children('select').append('<option value=' + $(this).data('field-name') + '>' + $(this).data('field-title') + '</option>');
          $(this).parents('div.form-group').remove();
        } else {
          $selectContainer.children('select').addClass('d-none');
          $newFieldButtonContainer.children('button').removeClass('d-none');
          $(this).addClass('d-none');
        }
      });

      $selectContainer.find('select').on('change', function () {
        registerChanges();

        let $selected = $(this).find(':selected')
        let fieldName = $selected.val();
        let title = $selected.text();
        let $newFieldTpl = $(_newFieldTpl({'name': fieldName, 'title': title}));
        let $newFieldViewTpl = $(_newFieldViewTpl({'name': fieldName, 'title': title}));

        $newFieldTpl.find('.remove-field-tpl a').on('click', function () {
          registerChanges();

          let $formGroup = $(this).parent().parent();
          let id = $formGroup.find('input').attr('id');

          $('span.fillable[data-name='+id+']').parent().remove();
          $selectContainer.find('select').children('option[value=' + id + ']').removeClass('d-none').removeAttr('disabled');
          $formGroup.remove();

          // show "plus" button, because there is a chance that it could be hidden
          $newFieldButtonContainer.children('button').removeClass('d-none');
        })

        $newFieldTpl.find('input').change(function (e) {
          pullChanges($(e.target));
        })

        $applicantForm.append($newFieldTpl)
        $('.changeable').append($newFieldViewTpl);

        $removeFieldButtonContainer.children('button').addClass('d-none');

        $(this).get(0).selectedIndex=0
        $selected.addClass('d-none').attr('disabled', 'disabled');
        $(this).addClass('d-none');

        // if now there are no options left except the default one - hide "plus" button
        if ($(this).find('option:not(.d-none)[value!=""]').length > 0) {
          $newFieldButtonContainer.children('button').removeClass('d-none');
        }
      })

      $('input.fillable').change(function (){
        pullChanges($(this));
      })

      $steps.first().parent().addClass('active');
      $steps.first().parent().addClass('visited');

      $wizardContainer.on('slid.bs.carousel', function () {
        let current = $('.carousel-item.active').index();
        $steps.each(function (index) {
          if (index === current) {
            $(this).parent().addClass('visited');
            $(this).parent().addClass('active');
          } else {
            $(this).parent().removeClass('active');
          }
        })
      })

      $('button.result').click(function () {
        registerChanges();

        handleVerificationStepResult(
          $(this).data('step'),
          $(this).data('result')
        );
      })

      $okModalButton.click(function () {
        ['front', 'back', 'face', 'final'].forEach(function (step_result) {
          $('<input>')
            .attr('type', 'hidden')
            .attr('name', 'result['+ step_result +']')
            .val(result[step_result])
            .appendTo($applicantForm);
        })

        $applicantForm.find('input[name=_token]').val($('meta[name=csrf-token]').attr('content'));
        disableLeaveConfirmationPopup();
        $applicantForm.submit();
      })
    }

    $('button.continue').on('click', function(){
      if ($wizard.find('div.carousel-item.active').data('step') === 'front') {
        if(!validateUserFields()) {
          return false;
        }
      }

      $('form.applicant_form input').removeClass('invalid-field');
      $('div.invalid-field').addClass('d-none');
      $wizard.carousel('next');
    });

    $('button.previous').on('click', function(){
      $wizard.carousel('prev');
    });

    $steps.on('click', function() {
      if ($wizard.find('div.carousel-item.active').data('step') === 'front') {
        if(!validateUserFields()) {
          return false;
        }
      }

      $('form.applicant_form input').removeClass('invalid-field');
      $('div.invalid-field').addClass('d-none');
      $wizard.carousel($(this).data('step'));
    });
  }

  $('.panel-collapse').on('show.bs.collapse', function () {
    $(this).siblings('.panel-heading').addClass('active');
  });

  $('.panel-collapse').on('hide.bs.collapse', function () {
    $(this).siblings('.panel-heading').removeClass('active');
  });

  function validateUserFields() {
    let validator = new UserFieldValidator();

    let valid = true;
    $('form.applicant_form input').each((i, input) => {
      let fieldName = $(input).data('field-name');
      let value = input.value;

      if (fieldName && value) {
        let validationResult = validator.validate(fieldName, value);

        if (validationResult && validationResult.result == false) {
          valid = false;
          let $validationErrorDiv = $('form div.invalid-field[data-field-name='+fieldName+']');
          $(input).addClass('invalid-field');
          $validationErrorDiv.text(validationResult.message);
          $validationErrorDiv.removeClass('d-none');
        } else {
          let $validationErrorDiv = $('form div.invalid-field[data-field-name='+fieldName+']');
          $(input).removeClass('invalid-field');
          $validationErrorDiv.addClass('d-none');
        }
      }
    });

    return valid;
  }
}());
